import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  public statistics = [{
    label: 'MEMBERS',
    entity: 'Member',
    bg: 'info',
    icon: 'cil-running',
    count: 0,
    url: '/members',
  }, {
    label: 'FITNESSRESERVATIONS',
    entity: 'FitnessReservation',
    bg: 'warning',
    icon: 'sli-event',
    count: 0,
    url: '/fitness-reservations',
  }, {
    label: 'FITNESSSESSIONS',
    entity: 'FitnessSession',
    bg: 'purple',
    icon: 'sli-calendar',
    count: 0,
    url: '/fitness-sessions',
  }, {
    label: 'VIDEOS',
    entity: 'Video',
    bg: 'danger',
    icon: 'sli-film',
    count: 0,
    url: '/videos',
  },
  {
    label: 'POSTS',
    entity: 'Post',
    bg: 'indigo',
    icon: 'cil-newspaper',
    count: 0,
    url: '/posts',
  },
  {
    label: 'COACHES',
    entity: 'Coach',
    bg: 'secondary',
    icon: 'cil-voice-over-record',
    count: 0,
    url: '/coaches',
  }, {
    label: 'FITNESSCLASSES',
    entity: 'FitnessClass',
    bg: 'success',
    icon: 'cil-weightlifitng',
    count: 0,
    url: '/fitness-classes',
  }, {
    label: 'SPORTS',
    entity: 'Sport',
    bg: 'dark',
    icon: 'sli-energy',
    count: 0,
    url: '/sports',
  }, {
    label: 'COMMENTS',
    entity: 'Comment',
    bg: 'pink',
    icon: 'sli-bubbles',
    count: 0,
    url: '/comments',
  },
  {
    label: 'CHALLENGES',
    entity: 'Challenge',
    bg: 'indigo',
    icon: 'cil-weightlifitng',
    count: 0,
    url: '/challenges',
  },];

  constructor(private dashboardService: DashboardService) {

  }

  ngOnInit(): void {
    this.getStatistics();
  }

  ngOnDestroy(): void {
  }

  getStatistics() {

    this.dashboardService.total(this.statistics[0].entity).subscribe((response: any) => {
      this.statistics[0].count = response.count;
    });
    this.dashboardService.total(this.statistics[1].entity).subscribe((response: any) => {
      this.statistics[1].count = response.count;
    });
    this.dashboardService.total(this.statistics[2].entity).subscribe((response: any) => {
      this.statistics[2].count = response.count;
    });
    this.dashboardService.total(this.statistics[3].entity).subscribe((response: any) => {
      this.statistics[3].count = response.count;
    });
    this.dashboardService.total(this.statistics[4].entity).subscribe((response: any) => {
      this.statistics[4].count = response.count;
    });
    this.dashboardService.total(this.statistics[5].entity).subscribe((response: any) => {
      this.statistics[5].count = response.count;
    });
    this.dashboardService.total(this.statistics[6].entity).subscribe((response: any) => {
      this.statistics[6].count = response.count;
    });
    this.dashboardService.total(this.statistics[7].entity).subscribe((response: any) => {
      this.statistics[7].count = response.count;
    });
    this.dashboardService.total(this.statistics[8].entity).subscribe((response: any) => {
      this.statistics[8].count = response.count;
    });
  }

}
